const SELECTED_PROGRAM_STORAGE_KEY = "lae:selected-program";

const PROGRAM_DATA_KEYS = Object.freeze({
  5: "program5",
  6: "program6",
});

const getBrowserStorage = () =>
  typeof window !== "undefined" ? window.localStorage : null;

export const isValidProgramDataKey = (value) =>
  value === PROGRAM_DATA_KEYS[5] || value === PROGRAM_DATA_KEYS[6];

export const toProgramDataKey = (program) => {
  if (isValidProgramDataKey(program)) return program;

  return PROGRAM_DATA_KEYS[Number(program)] || null;
};

export const setSelectedProgramDataKey = (
  dataKey,
  storage = getBrowserStorage()
) => {
  if (!storage) return null;

  if (!isValidProgramDataKey(dataKey)) {
    storage.removeItem(SELECTED_PROGRAM_STORAGE_KEY);
    return null;
  }

  storage.setItem(SELECTED_PROGRAM_STORAGE_KEY, dataKey);
  return dataKey;
};

export const clearSelectedProgramDataKey = (storage = getBrowserStorage()) => {
  storage?.removeItem(SELECTED_PROGRAM_STORAGE_KEY);
};

export const getSelectedProgramDataKey = (storage = getBrowserStorage()) => {
  if (!storage) return null;

  const dataKey = storage.getItem(SELECTED_PROGRAM_STORAGE_KEY);

  if (!isValidProgramDataKey(dataKey)) {
    storage.removeItem(SELECTED_PROGRAM_STORAGE_KEY);
    return null;
  }

  return dataKey;
};
